<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_iv"></a>S<span class="smallcaps">T</span>. M<span class="smallcaps">ARTIN’S</span> P<span class="smallcaps">APERBACKS</span> T<span class="smallcaps">ITLES</span><br/>B<span class="smallcaps">Y</span> C<span class="smallcaps">AITLIN</span> K<span class="smallcaps">ITTREDGE</span></p>
<p class="para"> </p>
<p class="center-para"><em>Night Life</em></p>
<p class="para"> </p>
<p class="center-para"><em>Pure Blood</em></p>
<p class="para"> </p>
<p class="center-para"><em>Second Skin</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?caa71c7c